module.exports = __webpack_public_path__ + "img/researchers.097421b7.png";